import { useEffect, useState } from "react";

import ShowPriceWithIcon from "./showPriceWithIcon";
import { useSelector } from "react-redux";

const TestPrice = ({
    price,
    maxPrice,
    minPrice,
    textColor = "textColor",
    textSize = "text-base",
}) => {
    const [isMounted, setIsMounted] = useState(false);
    const HOOKCITY = useSelector((state) => state?.hookCity?.cityId);
    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) return null; // Avoid hydration mismatch
    const testPrice = price && price[HOOKCITY];

    return (
        <div
            className={`flex flex-row items-center text-right ${textColor} gap-0.5`}
        >
            {(testPrice?.max_rate === 0 && testPrice?.min_rate == 0) ||
            testPrice == undefined ? (
                maxPrice === minPrice ? (
                    <ShowPriceWithIcon
                        price={maxPrice}
                        textColor={textColor}
                        textSize={textSize}
                    />
                ) : (
                    <>
                        <ShowPriceWithIcon
                            price={minPrice}
                            textColor={textColor}
                            textSize={textSize}
                        />
                        <p className={`${textColor} font-bold`}>-</p>
                        <ShowPriceWithIcon
                            price={maxPrice}
                            textColor={textColor}
                            textSize={textSize}
                        />
                    </>
                )
            ) : testPrice?.max_rate === testPrice?.min_rate ? (
                <ShowPriceWithIcon
                    price={testPrice?.max_rate}
                    textColor={textColor}
                    textSize={textSize}
                />
            ) : (
                <>
                    <ShowPriceWithIcon
                        price={testPrice?.min_rate}
                        textColor={textColor}
                        textSize={textSize}
                    />
                    <p className={`${textColor} font-bold mx-1`}>-</p>
                    <ShowPriceWithIcon
                        price={testPrice?.max_rate}
                        textColor={textColor}
                        textSize={textSize}
                    />
                </>
            )}
        </div>
    );
};

export default TestPrice;
